import axios from "axios";
const jsonConfig = require("../../Config.json");

const initiateinterview = async (payload) => {

    let allResponse = {}
    try {
        allResponse = await axios.post(`${jsonConfig.apiUrl}screeningstatusupdate`,payload, {
            headers: {
                "x-functions-key": jsonConfig.key,
            }
        });

        return Promise.resolve(allResponse)

    } catch (error) {
        return Promise.reject(error)
    }
}

export default initiateinterview
